export default __webpack_public_path__ + "static/media/EDISON_DS-BoK-release3-v06.4348fadd.pdf";